import { render, staticRenderFns } from "./payCenter.vue?vue&type=template&id=2ce7fc6f&scoped=true&"
import script from "./payCenter.vue?vue&type=script&lang=js&"
export * from "./payCenter.vue?vue&type=script&lang=js&"
import style0 from "./payCenter.vue?vue&type=style&index=0&id=2ce7fc6f&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./payCenter.vue?vue&type=style&index=1&id=2ce7fc6f&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce7fc6f",
  null
  
)

export default component.exports